module.exports = __webpack_public_path__ + "static/media/beach-view.c93944bb.jpeg";